export default {
    // 通用提示后缀, 减少重复代码
    common: {
        server_error: '服务异常',
        cancel: '取消',
        ok: '确定',
        preview: '查看',
        editor: '编辑',
        export: '导出',
        action: '操作',
        empty: '暂无数据',
        close: '关闭',
        update: '创建/更新',
        please_enter: '请输入',
        delete: '删除',
        add: '添加',
        save: '保存',
        Please_enter: '请输入',
        Submitted_successfully: '提交成功',
        Submission_failed: '提交失败',
        Successful_joining: '加入成功',
        Failed_to_join: '加入失败',
        Language_switch_successful: '语言切换成功',
        added_to_the_attachment: '已加入附件中',
        Execution_exception: '执行异常',
        Deletion_failed: '删除失败',
        System_prompt: '系统提示',
        sure_delete_conversation: '您确定删除该条对话吗?',
        Modification_successful: '修改成功',
        Modification_failed: '修改失败',
        Please_enter_question: '请输入您的问题',
        Thinking: '正在思考...',
        Service_request_exception: '服务请求异常',
        No_permission_operation: '对不起，您无该操作权限',

    },
    status: {
        unanalysis: '未分析',
        analyzing: '分析中',
        reanalyzing: '重新分析',
        analysis_completed: '分析结束',
        analysis_error: '分析失败',
        Invoke_the_tool: '调用工具',
        Tool_thinking_results: '工具思考结果',
        reanalysis_error: '分析失败',
        reviewed: '已审核',
        unreviewed: '待审核',
    },
    login: {
        welcome: '欢迎使用~',
        login: '登录',
        logout: '退出登录',
        phone: '账户名称',
        password: '密码',
        picture_code: '图形验证码',
        sms_code: '短信验证码',
        confirm_password: '确认密码',
        new_password: '新密码',
        confirm_new_password: '确认新密码',
        change_password: '修改密码',
        change_password_success: '密码修改成功',
        password_not_match: '两次输入的密码不一致',
        login_failure: '登录失败',
        login_success: '登录成功',
        enter_mobile: '请输入账户名称',
        enter_password: '请输入密码',
        enter_graphic: '请输入图形验证码',
        enter_sms: '请输入短信验证码',
        please_enter: '请输入',
        click_refresh: '点击刷新',
        sms_login: '验证码登录',
        password_login: '密码登录',
        get_sms: '获取验证码',
        forget_password: '忘记密码',
        have_no_account: "还没账号？前往",
        register: '注册',
        Visitor_login: '游客登录',
        rights_reserved: '保留所有权利',
        retrieve_password: '找回密码',
        update_password: '修改密码',
        solve_with_ai: '用AI技术解决病理学难题',
        highlights: '多尺度分析 丨 多算法兼容 丨多尺度特征记录 丨 报告整理生成',
        new_password: '新密码',
        enter_new_password: '请输入新密码',
        enter_confirm_password: '请输入确认密码',
    },
    home: {
        Pathological_system: '病理AI评分系统',
        WSI_image: 'WSI图像',
        Pathological_image: '病理图像',
        Ai_Assistant: 'Ai助手',
        Please_WSI_image: '请选择WSI图像',
        you_generate_AI_reports: '可直接查看图像进行分析并生成AI报告',
        zoom: '缩放:',
        Pixel_size: '像素尺寸',
        Pixel: '像素',
        Viewport: '视口',
        Business_serial_number: '业务流水号：',
        Status: '状态：',
        File_name: '文件名：',
        Select_reanalyze_it: '选择提示词重新分析',
        Reanalyze: '重新分析',
        Hide: '隐藏',
        Display: '显示',
        Key_area: '关键区域',
        Key_discovery: '重点发现',
        Detailed_discovery: '详细发现',
        A_further_summary: '进一步放大的总结',
        Return_to_analysis: '返回总体分析',
        Display_all_paths: '显示全部路径',
        Click_on_the_colored: '（点击WSI中的彩色区域查看区域分析）',
        Key_path: '关键路径',
        Path_summary: '路径摘要',
        Path_analysis: '路径分析',
        Magnification: '倍放大',
        Join_the_report: '加入报告',
        Join_AI_conversations: '加入AI对话',
        zoom_in: '放大',
        zoom_out: '缩小',
        Refresh: '刷新',
        Full_screen: '全屏',
        Fold_all: '全部折叠',
        Fully_unfold: '全部展开',
        Adapt_to_the_screen: '适应屏幕',
        Unfocus: '取消焦点',
        Create_a_new_conversation: '创建新对话',
        View_historical_conversations: '查看历史对话',
        Refresh_the_conversation: '刷新对话',
        your_assistant: 'Hi，我是您的助手！请选择病理报告选择一个病理报告后，即可开始与AI助手对话，快来试试吧！',
        Please_enter_new_name: '请输入新名称',
        Current: '当前',
        Release_add_attachments: '松开鼠标可添加附件',
        Input_message: '输入消息...',
        No_attachment: '暂无附件',
        right_click_add_tile: '可在SVS查看器中右键添加tile',
        Attachment: '附件',
        Clear: '清空',
        Press_Enter_to_send: '按 Enter 发送消息，Shift + Enter 换行',
        Layer_node: '层节点',
        // Tab 标题
        Overall_analysis: '总体分析',
        Path_analysis: '路径分析',
        Tree_analysis: '树图分析',
        Review_scoring: '审核打分',
        Microscopic_findings: '镜下所见',
        // 审核评分
        Score_roi_selection: 'RoI选择准确性',
        Score_roi_selection_desc: '评估模型选择的感兴趣区域是否准确 (0-5分)',
        Score_roi_summary: 'RoI总结情况',
        Score_roi_summary_desc: '评估关键路径分析的质量 (对应 critical_paths)',
        Score_slide_diagnosis: 'Slide-level诊断',
        Score_slide_diagnosis_desc: '评估镜下所见诊断的生成质量 (对应 microscopic_findings)',
        Review_comment: '审核备注',
        Review_comment_placeholder: '请输入审核备注（可选）',
        Submit_review: '提交评分',
        Review_submit_success: '评分提交成功',
        Review_submit_failed: '评分提交失败',
        Please_score_roi_selection: '请对RoI选择准确性进行评分',
        Please_score_roi_summary: '请对RoI总结情况进行评分',
        Please_score_slide_diagnosis: '请对Slide-level诊断进行评分',
    },
    prompt: {
        prompt_word_config: '提示词配置',
        system_prompt: '系统提示词',
        custom_prompt: '自定义提示词',
        prompt_search: '请输入提示词名称或所属器官搜索',
        prompt_name: '提示词名称',
        organ_which: '所属器官',
        last_updated: '最近更新时间',
        preview_prompt: '查看WSI提示词',
        sys_desc: '系统性描述',
        terminology_diagnostic: '术语与诊断基准',
        config_prompt_word_description: '目录层级（descriptors、diagnosers、rag_agents、summarizers）暂不支持直接配置“Q&A”、“系统性描述”和“术语诊断基准”等提示词。如需为其配置上述提示词，您需要先在该目录下创建或选择一个具体的​​配置项​​，随后即可在该配置项中进行提示词设置。',
        prompt_update_tip: '此操作将为您初始化或更新该器官类型的提示词。若您已有该器官自定义提示词，系统将会覆盖已有内容，请谨慎操作。',
        edit_prompt: '编辑WSI提示词',
        report_preview: '病理分析报告预览',
        report_number: '报告编号',
        regenerate_PDF: '重新生成PDF',
        report_PDF_loading: '正在生成病理报告PDF',
        file_name: '文件名',
        pdf_error: 'PDF生成失败，请稍后重试！',
        pdf_reload: '重新加载',
        analysis_path_select: '分析路径选择',
        pdf_selected: '已选择',
        analysis_path: '分析路径',
        unit: '个',
        total: '共',
        tile: '瓦片',
        selected: '已选中',
        include: '包含',
        remove_pdf: '从PDF中移除',
        join_pdf: '加入PDF',
        remove_all: '移除',
        unit_times: '倍',
        magnify: '放大',
        depth: '深度',
        sequence: '顺序',
    },
    slice: {
        Slice_analysis_list: '切片分析列表',
        Organ_name: '器官名称',
        File_name: '文件名',
        WSI_status: 'WSI状态',
        Review_status: '审核状态',
        Batch_analysis: '批量分析',
        Submit_for_analysis: '提交分析',
        Reset: '重置',
        Selected: '已选择',
        One_piece_data: ' 条数据',
        View_the_report: '查看报告',
        For_more_details: '查看详情',
        Organ: '器官',
        Status: '状态',
        Load_image: '加载图像',
        Load_result: '加载结果',
        Prompt_word: '提示词',
        Upload_time: '上传时间',
        Operation: '操作',
        Search_image_ID: '搜索图像ID',
    }
}